/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Edge_ConditionsInputs */

const cs_workflow_edge_conditions = /** @type {(inputs: Workflow_Edge_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podmínky spojení`)
};

const en_workflow_edge_conditions = /** @type {(inputs: Workflow_Edge_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edge conditions`)
};

/**
* | output |
* | --- |
* | "Edge conditions" |
*
* @param {Workflow_Edge_ConditionsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_edge_conditions = /** @type {((inputs?: Workflow_Edge_ConditionsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Edge_ConditionsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_edge_conditions(inputs)
	return cs_workflow_edge_conditions(inputs)
});